module.exports = __webpack_public_path__ + "img/oi.38cb9eb0.png";